<section class="Forums__Header">
  <div class="container">
    <div class="row">
      <div class="Forums__Header--text col-12 col-md-4">
        <h1 i18n>Seguimiento</h1>
        <h3 i18n>Gestiona de manera sencilla los cuestionarios iniciales y de seguimiento en orden cronológico para tener un mayor control y ofrecer un mejor servicio a tus clientes.</h3>
        <p class="mt-2 bh-badge badge-primary black" i18n>Esta función se encuentra en Versión Beta.</p>
      </div>
      <div class="OverviewBanner dakkini-card col-12 col-md-8 justify-content-right pt-0">
        <div class="py-3 px-1 px-md-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h3 class="text-uppercase ltspacing-2 m-0" i18n>Vista general</h3>
          
          <select class="form-select w-auto" (change)="onChangeMonth($event)">
            <option value="" i18n>Todos los meses</option>
            <option *ngFor="let month of last12Months" [value]="month.value">
              {{ month.label }}
            </option>
          </select>
        </div>

        <div class="border-top py-3 px-2 px-md-3 row">
          <div class="col-6 col-md-3">
            <p class="numberBold">{{ overviewQnnairesAnalytics?.qnnaires_follow_up_semaphores_total_counter || 0 | number }}</p>
            <p i18n>Experiencias Registradas</p>
          </div>
          <div class="col-6 col-md-3">
            <p class="numberBold">
              {{ overviewQnnairesAnalytics?.qnnaires_follow_up_as_positive || 0 | number }}
              <span>({{ overviewQnnairesAnalytics?.positive_percentage || 0 }}%)</span>
            </p>
            <p i18n>Experiencia Positiva</p>
          </div>
          <div class="col-6 col-md-3">
            <p class="numberBold">
              {{ overviewQnnairesAnalytics?.qnnaires_follow_up_as_neutral || 0 | number }}
              <span>({{ overviewQnnairesAnalytics?.neutral_percentage || 0 }}%)</span>
            </p>
            <p i18n>Experiencia Neutra</p>
          </div>
          <div class="col-6 col-md-3">
            <p class="numberBold">
              {{ overviewQnnairesAnalytics?.qnnaires_follow_up_as_negative || 0 | number }}
              <span>({{ overviewQnnairesAnalytics?.negative_percentage || 0 }}%)</span>
            </p>
            <p i18n>Experiencia Negativa</p>
          </div>
          <div class="col-6 col-md-6">
            <p class="numberBold">{{ overviewQnnairesAnalytics?.qnnaires_reviewed || 0 | number }}</p>
            <p i18n>Cuest. Seguimiento Revisados</p>
          </div>
          <div class="col-6 col-md-6">
            <p class="numberBold wrong" i18n>{{ overviewQnnairesAnalytics?.qnnaires_not_reviewed || 0 | number }}</p>
            <p i18n>Cuest. Seguimiento Sin Revisar</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="container mb-3">
  <div class="tabs">
    <div *ngFor="let status of statusEntries;">
      <button
        class="tabButton"
        [class]="{ active: activeTab === status[0] }"
        (click)="tabChange(status[0])"
      >
        {{ status[1] }} <span *ngIf="activeTab === status[0] && this.totalQuestionnaires" class="counter">{{this.totalQuestionnaires}}</span>
      </button>
    </div>
  </div>
  <div class="tabs mt-2" *ngIf="activeTab === 'followUp'">
    <div *ngFor="let status of satisfactionLevelFilters;">
      <button
        class="tabButton"
        [class]="{ active: activeSatisfactionLevelTab === status[0] }"
        (click)="tabChangeSatisfactionLevel(status[0])"
      >
      {{ status[1] }}
      </button>
    </div>
  </div>
</div>
<div class="container">
  <ag-grid-angular
    style="width: 100%; height: 800px;"
    class="ag-theme-material"
    [datasource]="dataSource"
    [columnDefs]="columnDefs"
    [rowMultiSelectWithClick]="true"
    rowModelType="infinite"
    [pagination]="true"
    [animateRows]="true"
    [paginationPageSizeSelector]="[50, 100, 200, 300]"
    [paginationPageSize]="50"
    [cacheBlockSize]="50"
    [infiniteInitialRowCount]="0"
    (rowClicked)="onRowClicked($event)"
    [getRowStyle]="rowStyle"
    [loading]="loading"
    [suppressMovableColumns]="true"
    [suppressCellFocus]="true"
    ></ag-grid-angular>
</div>